module.exports = __webpack_public_path__ + "media/country_flags/gt-ff2a3c6e.png";